import { render, staticRenderFns } from "./publishRegister.vue?vue&type=template&id=e004cd8a&scoped=true&"
import script from "./publishRegister.vue?vue&type=script&lang=js&"
export * from "./publishRegister.vue?vue&type=script&lang=js&"
import style0 from "./publishRegister.vue?vue&type=style&index=0&id=e004cd8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e004cd8a",
  null
  
)

export default component.exports